import { ACTION_TYPES } from './sendedEmail.constant';

export const SendedEmail = () => ({
  type: ACTION_TYPES.SENDED_EMAIL,
});
